// State module for dashboard information

import SelectedRequests from '@/store/modules/dashboard/SelectedRequests';
import BaseModulePlugins from '@/store/baseModule/plugins';
import registerDashboard from './dashboard.store';

export default (store) => {
  registerDashboard(store);

  store.registerModule('dashboard/selected', SelectedRequests);

  const basePlugins = new BaseModulePlugins({
    module: 'dashboard/selected',
    store,
  });

  basePlugins.persistVuexMutationsToLocalStorage(['SET_PARAMS']);
};
